define('components/videofactory/enum/EnumVideoType', [

], function(){

    return {
        HTML_VIDEO: "html",
        MMM_VIDEO: "mmm",
        YOUTUBE_VIDEO: "youtube"
    };
});
